import React, { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import {validateForm} from '../formValidator';
import { isNullOrEmpty } from '../helpers';

import { API, FAST_ANIMATION } from '../../../ws/constants';

var moment = require('moment');

class DayOffModalBox extends PureComponent {
    /* START Constructor */

    constructor(props) {
        super(props);

        this.state = {
            dayOffId:typeof this.props.dayOffId !== "undefined" && !isNullOrEmpty(this.props.dayOffId) ? this.props.dayOffId : "New"
            , isVisible:false
            , loading:false
            , staffId:this.props.staffId
            , fetchReasons:null
            , dayOff:0
            , reasonId:"1"
            , dateStarted: moment(this.props.dateStarted).format('YYYY-MM-DD')
            , dateEnded: moment(this.props.dateEnded).format('YYYY-MM-DD')
            , notes:""
        };
    }

    /* END Constructor */

    /* START React own Functions */

    componentDidMount(){
        const isNotNew = this.state.dayOffId !== "New";
        const fetches = [fetch(API + "getholidayreasons")];

        if(isNotNew)
            fetches.push(fetch(API + "getdayoff&getbyid="+this.state.dayOffId));

        this.setState({loading:true});
        setTimeout(() => {
            this.setState({isVisible:true});
        }, FAST_ANIMATION);

        Promise.all(fetches)
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            let newState = {fetchReasons:data[0].data, loading:false};
            if(typeof data[1] !== "undefined" && typeof data[1].data !== "undefined"){
                const dayOffData = data[1].data
                newState = {
                    dayOff:1
                    , reasonId:dayOffData[0].ReasonId
                    , notes:dayOffData[0].Notes
                    , staffId:dayOffData[0].StaffId
                    , dateStarted: moment(dayOffData[0].DateStart).format('YYYY-MM-DD')
                    , dateEnded: moment(dayOffData[0].DateEnd).format('YYYY-MM-DD')
                    , ...newState
                }
            }

            this.setState(newState);
        });
    }

    /* END React own Functions */

    /* START Handles */


    handleTitleChange = (e) => this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });
    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value, somethingWasEdited:true });

    handleOk = (e) => {
        if(validateForm($(findDOMNode(this.refs.dayOffModalForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "savedayoff&dayoffid=" + this.state.dayOffId + "&staffid=" + this.state.staffId + "&dayOff=" + (this.state.dayOff ? '1' : '0') + "&reasonId=" + this.state.reasonId
                                + "&dateStarted=" + moment(this.state.dateStarted).format('YYYY-MM-DD') + "&dateEnded=" + moment(this.state.dateEnded).format('YYYY-MM-DD')
                                + "&notes=" + this.state.notes.trim() + "&cur_userid="+this.props.loginData.Id + "&cur_username="+this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {
                this.setState({loading:false, isVisible:false});
                setTimeout(() => {
                    this.props.modalCallBack(result, false);
                }, FAST_ANIMATION);
            });
        }
    }

    handleCancel = (e) => {
        this.setState({isVisible:false});
        setTimeout(() => {
            this.props.modalCallBack(false, false); // 1st param should be the result whilst the second should be (keepModalOpen)
        }, FAST_ANIMATION);
    }

    /* END Handles */

    /* START Component Functions */

    /* END Component Functions */

    /* START Renders */

    renderReasonsOptions = (e) => {
        const reasons = this.state.fetchReasons;
        if(reasons===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled>Escolha uma opção</MenuItem>];
        for (let i=0,n=reasons.length;i<n;i++) {
            items.push(<MenuItem value={reasons[i].Id}
                                 key={reasons[i].Id}>{reasons[i].Reason}</MenuItem>);
        }
        return items;
    }

    render() {
        const { editable } = this.props;
        
        const optsReasons = this.renderReasonsOptions()
              , activeClass = this.state.isVisible ? " active" : ""
              , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div className="form" ref="dayOffModalForm">
                <div className={"modalBox addEditPage" + activeClass + loadingClass}>
                    <button type="button" className="simpleBtn closeModal" onClick={this.handleCancel}><i className="fa fa-times"></i></button>
                    <div className="row">
                        <div className="col-12"><h2>Tirar o dia
                            <span className="float-right">
                                <FormControlLabel
                                    control={
                                        <Switch
                                            id="dayOff"
                                            checked={!!+this.state.dayOff}
                                            disabled={!editable}
                                            onChange={this.handleToggle}
                                            color="primary"/>
                                    }
                                    label="Sim"/>
                            </span></h2></div>
                        <div className="col-12">
                            <div className="fieldHolder required selectField">
                                <FormControl fullWidth>
                                    <InputLabel htmlFor={"reasonId"}>Escolha uma razão</InputLabel>
                                    <Select id="reasonId"
                                            name="reasonId"
                                            value={this.state.reasonId}
                                            onChange={this.handleSelectChange}
                                            disabled={!editable || !this.state.dayOff}
                                            data-empty-error-message="Este campo não pode estar vazio">
                                          {optsReasons}
                                     </Select>
                                 </FormControl>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TextField
                                    fullWidth
                                    id="dateStarted"
                                    name="dateStarted"
                                    label="Data de início"
                                    type="date"
                                    value={this.state.dateStarted}
                                    onChange={this.handleFieldChange}
                                    disabled={true}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}/>
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="fieldHolder">
                                <TextField
                                    fullWidth
                                    id="dateEnded"
                                    name="dateEnded"
                                    label="Data de fim"
                                    type="date"
                                    value={this.state.dateEnded}
                                    onChange={this.handleFieldChange}
                                    disabled={true}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}/>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="fieldHolder">
                                <TextField fullWidth
                                           id="notes"
                                           value={this.state.notes}
                                           onChange={this.handleFieldChange}
                                           disabled={!editable || !this.state.dayOff}
                                           rows={4}
                                           label="Observações"
                                           multiline />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 buttonsHolder">
                            <Button onClick={this.handleCancel} variant="contained" className="defaultButton">Cancelar</Button>
                            { editable && <Button onClick={this.handleOk} className="float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                        </div>
                    </div>
                </div>
                <div className={"darkOverlay " + activeClass}></div>
            </div>
        );
    }
}

export default DayOffModalBox;
